var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51471 12 7.49999 9.98528 7.49999 7.5C7.49999 5.01472 9.51471 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5ZM14.1 7.5C14.1 8.6598 13.1598 9.6 12 9.6C10.8402 9.6 9.89999 8.6598 9.89999 7.5C9.89999 6.3402 10.8402 5.4 12 5.4C13.1598 5.4 14.1 6.3402 14.1 7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C8.36817 21 5.33928 18.4186 4.64808 14.9904C4.48434 14.1783 5.17157 13.5 5.99999 13.5H18C18.8284 13.5 19.5156 14.1783 19.3519 14.9904C18.6607 18.4186 15.6318 21 12 21ZM12 18.6C13.9476 18.6 15.6431 17.5068 16.5019 15.9H7.4981C8.35685 17.5068 10.0524 18.6 12 18.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.db5e3b7025743b114e0a09e6167e720c.svg";
export { ForwardRef as ReactComponent };